<mat-card class="regulatory-title-card">
  <mat-card-header>
    <mat-card-title>{{ 'SMS_REGULATION.AUSTRALIA.TITLE' | translate }}</mat-card-title>
    <mat-card-subtitle>{{ 'SMS_REGULATION.AUSTRALIA.SUBTITLE' | translate }}</mat-card-subtitle>
  </mat-card-header>
</mat-card>

<form [formGroup]="formGroup">
  <fieldset
    class="regulatory-form-lock"
    [disabled]="$shouldFormBeLocked()"
    [attr.inert]="$shouldFormBeLocked() ? '' : null"
  >
  <div class="regulatory-form">
    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <sms-address-fields [parentFormGroup]="businessAddressFormGroup"></sms-address-fields>

          <sms-document-uploader
            [parentFormGroup]="businessAddressFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.COMMERCIAL_REGISTER',
                value: 'commercial_registrar_excerpt',
              },
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.UTILITY_BILL',
                value: 'utility_bill',
              },
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.TAX_NOTICE',
                value: 'tax_document',
              },
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.RENT_RECEIPT',
                value: 'rental_receipt',
              },
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.TITLE_DEED',
                value: 'title_deed',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.AUSTRALIA.BUSINESS_ADDRESS.ACCEPTED_DOCUMENTS.HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="regulatory-form-column">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content formGroupName="businessIdentity">
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.BUSINESS_NAME' | translate }}</glxy-label>
            <input matInput formControlName="businessName" />
          </glxy-form-field>
          <glxy-form-field [required]="true">
            <glxy-label>{{ 'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.BUSINESS_ID_NUMBER' | translate }}</glxy-label>
            <input matInput formControlName="businessIdNumber" />
            <glxy-hint>{{ 'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.BUSINESS_ID_NUMBER_HINT' | translate }}</glxy-hint>
          </glxy-form-field>

          <sms-document-uploader
            [parentFormGroup]="businessIdentityFormGroup"
            [options]="[
              {
                label: 'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.COMMERCIAL_REGISTER',
                value: 'commercial_registrar_excerpt',
              },
            ]"
            [fieldTitle]="'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.TITLE'"
            [fieldHint]="'SMS_REGULATION.AUSTRALIA.BUSINESS_IDENTITY.ACCEPTED_DOCUMENTS.UPLOAD_HINT'"
          ></sms-document-uploader>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  </fieldset>

  @if (!$shouldFormBeLocked() && !$submitting()) {
    <div class="regulatory-form-action-container">
      <button (click)="submitRegulatoryForm()" color="primary" mat-flat-button type="submit">
        @if ($isRejected()) {
          {{ 'SMS_REGULATION.COMMON.RESUBMIT' | translate }}
        } @else {
          {{ 'SMS_REGULATION.COMMON.SUBMIT' | translate }}
        }
      </button>
    </div>
  }
</form>
